import React, { useState } from 'react';
import { Button as DSButton } from '@designsystem/stories/02-atoms/Button';
import type { ButtonProps as DSButtonProps } from '@designsystem/stories/02-atoms/Button';

type ButtonProps = {
  label?: string;
  isDisabled?: boolean;
  isActive?: boolean;
  styles?: string;
  gaTrigger?: string;
  type?: 'button' | 'submit' | 'reset';
  onPress: (
    e: MouseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
  children?: React.ReactNode;
} & Omit<DSButtonProps, 'type'>;

const Button = ({
  label,
  isDisabled = false,
  isActive,
  styles,
  gaTrigger,
  type = 'button',
  onPress,
  children,
  ...props
}: ButtonProps) => {
  const [isPressed, setIsPressed] = useState(isActive);

  const toggleActive = () => {
    setIsPressed((isPressed) => !isPressed);
  };

  return (
    <DSButton
      label={label}
      className={gaTrigger}
      type={type === 'submit' ? 'primary' : 'secondary'}
      submit={type === 'submit'}
      reset={type === 'reset'}
      {...props}
      aria-label={label}
      data-is-active={isPressed}
      onClick={(
        e: MouseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>,
      ) => {
        toggleActive();
        onPress(e);
      }}
      disabled={isDisabled}
    >
      {children}
    </DSButton>
  );
};

export default Button;
